export enum RatingType {
  EXCELLENT = 'EXCELLENT',
  ACCEPT = 'ACCEPT',
  UNACCEPT = 'UNACCEPT',
  NULL = ''
}

export enum AnnotationKey {
  ALL = 'ALL',
  NoAnnotation = 'noAnnotation',
}

export enum StateType {
  ANNOTATED = 'ANNOTATED',
  SUBMITTED = 'SUBMITTED',
  UNSUBMITTED = 'UNSUBMITTED',
  UNANNOTATED = 'UNANNOTATED',
  NULL = '',
}

export interface QuestionItem {
  state: StateType,
  question: string,
  id: string,
}

export interface QuestionDetail {
  id: string,
  date: string,
  question: string,
  answer: string,
  rating: RatingType,
  annotator: string,
  annotationTime: string,
  state: StateType,
}

// 语料库标注业务场景
export const AnnotationScene = 'aiWriterPlatformWriting'